import { ReactComponent as JumpPrevIcon } from "../../common/images/svg/JumpPrev.svg";
import { ReactComponent as PrevIcon } from "../../common/images/svg/Prev.svg";

interface IPrevPaginationProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

const PrevPagination = ({
  currentPage,
  setCurrentPage,
}: IPrevPaginationProps) => {
  return (
    <div className="custom-paging">
      <div
        className="button-prev-next"
        onClick={(e) => {
          e.stopPropagation();
          if (currentPage > 3) setCurrentPage(currentPage - 3);
          else setCurrentPage(1);
        }}
      >
        <JumpPrevIcon />
      </div>
      <div
        className="button-prev-next"
        onClick={(e) => {
          e.stopPropagation();
          if (currentPage > 1) setCurrentPage(currentPage - 1);
        }}
      >
        <PrevIcon />
      </div>
    </div>
  );
};

export default PrevPagination;
